import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Routed page content region within the application shell.
 */
@Component({
  selector: 'app-shell-page-content',
  imports: [RouterOutlet],
  templateUrl: './shell-page-content.html',
  styleUrl: './shell-page-content.scss',
  encapsulation: ViewEncapsulation.None,
  host: { class: 'app-shell__content' },
})
export class ShellPageContent {}
